import { FieldConditionTypes } from '../types';

export const DEFAULT_CONDITION_FOR_TARGETED_FIELDS: FieldConditionTypes.ConditionOperation = 'show';
